import { usePreSelectedResourceStore } from "@/pages/taskpane/shared/stores/preSelectedResourceStore";
import { PreSelectedResourceInfo } from "@/pages/taskpane/shared/types/preSelectedResource";
import { useResourceStore } from "../../resources/store/resourceStore";
import { useOutlookActions } from "@/pages/taskpane/lib/office/hooks";
import { routes } from "@/pages/taskpane/shared/constants/routes";
import { useNavigate } from "react-router-dom";
import { EPreSelectedResource } from "@/pages/taskpane/shared/types/enums/preSelectedResourceEnum";

export const useMeetingType = () => {
  const navigate = useNavigate();
  const { removeItem, items } = usePreSelectedResourceStore();
  const { selectedResource, addSelectedResource } = useResourceStore();
  const { AddResources } = useOutlookActions();

  const onSelectMeetingType = (notifyInfo: PreSelectedResourceInfo) => {
    if (notifyInfo) {
      removeItem(notifyInfo);
      const itemsNotMeetingType = items?.filter(
        (i) => i.type !== EPreSelectedResource.MeetingType && i.isResourcePending
      );
      //lấy những resource không còn trong pending
      const resourceNotPending = notifyInfo.resources.filter(
        (r) => !itemsNotMeetingType?.some((i) => i.resources.some((r2) => r2.id === r.id))
      );
      const rsIds = selectedResource.map((r) => r.id);
      if (resourceNotPending.length > 0) {
        resourceNotPending.forEach((r) => {
          if (!rsIds.includes(r.id)) {
            addSelectedResource(r);
            AddResources([r]);
          }
        });
      }
    }
  };

  return {
    onSelectMeetingType,
  };
};
